import Constants from 'expo-constants'
import { FirebaseApp, getApp, getApps, initializeApp } from 'firebase/app'
import { getAnalytics, isSupported, type Analytics } from 'firebase/analytics'

const extra = (Constants.expoConfig?.extra ?? {}) as Record<string, string | undefined>

export const firebaseConfig = {
  apiKey: extra.EXPO_PUBLIC_FIREBASE_API_KEY,
  authDomain: extra.EXPO_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: extra.EXPO_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: extra.EXPO_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: extra.EXPO_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: extra.EXPO_PUBLIC_FIREBASE_APP_ID,
  measurementId: extra.EXPO_PUBLIC_FIREBASE_MEASUREMENT_ID,
  databaseURL: extra.EXPO_PUBLIC_FIREBASE_DATABASE_URL,
}

export const hasFirebaseConfig = Boolean(
  firebaseConfig.apiKey &&
    firebaseConfig.authDomain &&
    firebaseConfig.projectId &&
    firebaseConfig.appId
)

export const firebaseApp: FirebaseApp | null = hasFirebaseConfig
  ? getApps().length > 0
    ? getApp()
    : initializeApp(firebaseConfig)
  : null

let analyticsPromise: Promise<Analytics | null> | null = null

export const initialiseAnalytics = () => {
  if (typeof window === 'undefined' || !firebaseApp) {
    return Promise.resolve(null)
  }

  if (!analyticsPromise) {
    analyticsPromise = isSupported()
      .then(supported => (supported ? getAnalytics(firebaseApp) : null))
      .catch(() => null)
  }

  return analyticsPromise
}
